export default __webpack_public_path__ + "static/media/win-lazaro.ac15e227.png";